import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { registerUser } from "../api/api"
import { useAuth } from "./AuthProvider"

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" })
  const [error, setError] = useState("")
  const { login } = useAuth()
  const navigate = useNavigate()

  function update(field, value) {
    setForm((current) => ({ ...current, [field]: value }))
  }

  async function submit(e) {
    e.preventDefault()
    setError("")

    try {
      const res = await registerUser(form)
      login(res.data.token, res.data.user)
      navigate("/dashboard")
    } catch (err) {
      setError(err.response?.data?.error || "Registration is disabled")
    }
  }

  return (
    <form className="auth" onSubmit={submit}>
      <h1>Create account</h1>
      {error && <p className="error">{error}</p>}
      <input
        placeholder="Name"
        value={form.name}
        onChange={(e) => update("name", e.target.value)}
      />
      <input
        placeholder="Email"
        value={form.email}
        onChange={(e) => update("email", e.target.value)}
      />
      <input
        type="password"
        placeholder="Password (8+ characters)"
        value={form.password}
        onChange={(e) => update("password", e.target.value)}
      />
      <button type="submit">Register</button>
    </form>
  )
}
